import { ExportIcon } from "@xola/icons";
import { JsDateRange, now } from "common";
import React, { useState } from "react";
import { useQuery } from "react-query";
import { ExportJob, PayoutTransaction } from "types";
import shallow from "zustand/shallow";
import { api } from "../../../api/api";
import { useModal } from "../../../hooks/useVisibility";
import { getInitialDate } from "../../../models/Reports";
import { usePayoutFilterStore } from "../../../stores/reports/payoutFilterStore";
import { ExportJobModal } from "../../Common/ExportJobModal";
import { SecondaryButton } from "../../Common/SecondaryButton";
import { ReportDatePicker } from "../ReportDatePicker";

export const PayoutFilter = () => {
    const exportModal = useModal(false);

    const [from, to] = usePayoutFilterStore((state) => [state.getFrom(), state.getTo()], shallow);
    const [setFrom, setTo] = usePayoutFilterStore((state) => [state.setFrom, state.setTo], shallow);

    const [value, setValue] = useState(getInitialDate(from, to));
    const handleDateChange = (dateValue: JsDateRange) => {
        if (dateValue.from && dateValue.to) {
            setFrom(now(dateValue.from));
            setTo(now(dateValue.to));
        }

        setValue(dateValue);
    };

    return (
        <div className="flex flex-row items-center justify-between border-b border-gray-light px-6 py-3">
            <div className="flex w-full flex-row items-center justify-start space-x-1 xl:space-x-4">
                <div>
                    <ReportDatePicker max={now()} from={from} to={to} value={value} onChange={handleDateChange} />
                </div>
            </div>

            <div className="shrink-0 space-x-2 place-self-end pl-2">
                <SecondaryButton icon={<ExportIcon />} onClick={exportModal.show}>
                    Export
                </SecondaryButton>
            </div>
            <ExportPayoutEventsModal isOpen={exportModal.isVisible} onClose={exportModal.hide} />
        </div>
    );
};

interface ExportPayoutEventsModalProps {
    isOpen: boolean;
    onClose: (e: any) => void;
    payout?: PayoutTransaction;
}

export const ExportPayoutEventsModal = ({ isOpen, onClose, payout }: ExportPayoutEventsModalProps) => {
    const dateParams = usePayoutFilterStore((state) => state.getDateParams());
    const params: any = { format: "xlsx" };
    if (payout) {
        params.payout = payout.id;
        params.reportTitle = "payout_transactions";
    } else {
        Object.assign(params, dateParams);
        params.context = "payout_report";
    }

    const { data: job } = useQuery<ExportJob>(
        ["transactions", "payout", params],
        async () => {
            const { data } = await api.get<ExportJob>("/transactions", { params });
            return data;
        },
        { enabled: isOpen },
    );

    return <ExportJobModal isOpen={isOpen} job={job} onClose={onClose} />;
};
